module.exports = __webpack_public_path__ + "static/media/icon-action-call-gray.4955a455.svg";